import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { S3Client, GetObjectCommand } from "@aws-sdk/client-s3";
const s3Client = new S3Client({
  region: process.env.REACT_APP_S3_BUCKET_REGION || "",
  credentials: {
    accessKeyId: process.env.REACT_APP_S3_BUCKET_ACCESS_KEY_ID || "",
    secretAccessKey: process.env.REACT_APP_S3_BUCKET_SECRET_ACCESS_KEY || "",
  },
});
console.log(process.env.REACT_APP_S3_BUCKET_NAME,"REACT_S3_BUCKET_SECRET_ACCESS_KEY")
export const getImageUrl = async (
  Key: any,
  defaultFile: string | null = null,
  folderName = ""
): Promise<string> => {
  try {
    const command = new GetObjectCommand({
      Bucket: process.env.REACT_APP_S3_BUCKET_NAME || "tpl-backend-s3",
      Key: `${folderName}${Key}`,
    });
    return await getSignedUrl(s3Client, command, { expiresIn: 3000 });
  } catch (e) {
    console.error("Error fetching signed URL:", e);
    return defaultFile ?? ""; // null ho to empty string return karo
  }
};
